import { sendCPCLog } from '../utils/common';
import { SINGULAR_CONFIG } from '../utils/singularUtils';

/**
 * @export
 * @class CartManager
 * 카트 추가 등 액션 관리
 */
export default class CartManager {
  constructor() {
    if (!TMON.bLogin) {
      const sTmonCartCookie = $.cookie('TMON_CART');
      if (sTmonCartCookie && sTmonCartCookie.substring(0, 4) === 'TMON') {
        $.cookie('TMON_CART', null, {
          expires: 30,
          path: '/',
          domain: 'tmon.co.kr',
          secure: false,
        });
      }
    }
    this.setEvent();

    // 모웹에서 장바구니 바텀시트 애니메이션 처리를 위한 변수
    this.isDragging = false;
    this.startY = 0;
    this.startHeight = 0;
    this.originPopupHeight = 0;
  }

  setEvent() {
    $('[data-role=addCartWrap]').on(
      'click',
      '[data-role=closeThisPop]',
      this.hideCartPopup
    );
    $('[data-role=addCartWrap]').on("click", "[data-role=goCart]", () => {
      if ((TMON.view_mode === 'app')) {
        TMON.app.callApp('webview', 'goCart');
      } else {
        window.location.href = TMON.htLocal.htURL.www_cart;
      }
    });
  }

  setPopupEvent() {
    const anchorClassName = TMON.sDevice === 'PW' ? 'c-swiper' : 'card_deallist_list';
    $('[data-role=addCartWrap]').on("click", `.${anchorClassName} a`, (e) => {
      sendCPCLog([e.currentTarget], "CLICK", "CPC_AI");
    });

    if (TMON.sDevice !== 'PW') {
      const anchors = $('.card_deallist_list a');
      if (!anchors) return;

      const cpcAnchors = anchors.slice(0, 3);
      const sendImpressionLog = () => {
        if (cpcAnchors.length > 0) {
          sendCPCLog(cpcAnchors, "IMPRESSION", "CPC_AI");
          cpcAnchors.length = 0;
        }
      }

      // 바텀시트 오픈시 3개 딜 CPC 로그 호출
      sendImpressionLog();

      const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            cpcAnchors.push(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });
      Array.from(anchors.slice(3)) 
        .forEach((anchor) => io.observe(anchor));

      // 스크롤이 끝났을 때 CPC 로그 호출
      $('.card_deallist_body').on("mouseup", sendImpressionLog);
      $('.card_deallist_body').on("touchend", sendImpressionLog);

      // 바텀시트 애니메이션
      const bottomSheet = $(".keep-cart");
      bottomSheet.on("mousedown", this.dragStart);
      bottomSheet.on("mousemove", this.dragging);
      bottomSheet.on("mouseup", this.dragStop);
      bottomSheet.on("touchstart", this.dragStart);
      bottomSheet.on("touchmove", this.dragging);
      bottomSheet.on("touchend", this.dragStop);

      $(window).on("pageshow", this.hideCartPopup);
    }
  }

  setHideBottomEvent () {
    // 바텀시트 닫기
    $("#view-default").on("touchstart", this.onClickOutsidePopup);
    $("#view-default").on("click", this.onClickOutsidePopup);
  }

  clearEvent() {
    $('[data-role=addCartWrap]').off('mouseover');
    $('[data-role=addCartWrap]').off('mouseout');
    $('[data-role=addCartWrap]').off('click', '.btn_clse');
    $('[data-role=addCartWrap]').off('click', '[data-role=closeThisPop]');
  }

  dragStart = (e) => {
    const dealListWrap = $('.card_deallist_list');
    if (dealListWrap.has(e.target).length) return;
    
    const bottomSheet = $(".keep-cart");
    const sheetContent = $(".keep-cart__content");
    this.isDragging = true;
    this.startY = e.pageY || e.touches && e.touches[0].pageY;
    this.startHeight = parseInt(sheetContent.height(), 10);
    bottomSheet.addClass("dragging");
  }

  dragging = (e) => {
    if(!this.isDragging) return;
    const delta = this.startY - (e.pageY || e.touches && e.touches[0].pageY);
    const newHeight = this.startHeight + delta;
    if (this.startHeight > newHeight) {
      this.updateSheetHeight(newHeight);
    }
  }

  dragStop = () => {
    const bottomSheet = $(".keep-cart");
    const sheetContent = $(".keep-cart__content");
    this.isDragging = false;
    bottomSheet.removeClass("dragging");
    const sheetHeight = parseInt(sheetContent.height(), 10);
    if (sheetHeight < 200) {
      this.hideCartPopup();
    } else {
      this.updateSheetHeight(this.originPopupHeight);
    }
  }

  updateSheetHeight(height) {
    const bottomSheet = $(".keep-cart");
    const sheetContent = $(".keep-cart__content");
    sheetContent.css('height', `${height}px`);
    bottomSheet.toggleClass("fullscreen", height === 100);
  }

  hideCartPopup = () => {
    $('[data-role=addCartWrap]').hide();
    if (TMON.sDevice !== 'PW') {
      $("body").css('overflow', '');
      $("body").css('position', '');

      $('.keep-cart__content').height(this.originPopupHeight);
      $("#view-default").off("touchstart", this.onClickOutsidePopup);
      $("#view-default").off("click", this.onClickOutsidePopup);
    }
    if (this.oSwiper) {
      this.oSwiper.destroy();
    }
  }

  onClickOutsidePopup = (e) => {
    const popupWrap = $('.keep-cart');
    // 바텀시트 바깥영역 클릭시 바텀시트 닫음
    if (!popupWrap.has(e.target).length) {
      this.hideCartPopup();
    }
  }

  update(sStorageKey) {
    switch (sStorageKey) {
      case 'willAddToCart':
        this.addCart();
        break;
      case 'addCartItems':
        this.processCartAdded();
        break;
      default:
        break;
    }
  }

  /**
   * willAddToCart storage의 값으로 카트담기 요청을 보냄
   */
  addCart() {
    TMON.bIsAvailAddToCart = false;

    const {
      sMainDealSrlForCart,
      aOptionNoForCart,
      aCountForCart,
      aPrice,
    } = TMON.oApp.htStorage.willAddToCart;

    const { userCartKeyAtNonLogin } = TMON.oApp.htStorage.htStaticData;

    // app일 때 addToCart 콜앱 호출
    if (TMON.view_mode === 'app') {
      TMON.app.callApp(
        'webview',
        'addToCart',
        sMainDealSrlForCart.toString(),
        aOptionNoForCart.join(','),
        aCountForCart.join(','),
        'TMON.oDealMain.oCallWeb.completeAddToCart'
      );
    // 앱이 아니면 addCartItems 호출
    } else {
      // [SDLUI-2158] Appendix 특정 제휴사 유입코드인 경우 제휴사 혜택 문구 처리
      // Appendix 특정 제휴사 메타채널 유입 여부 서버 관리 필요
      if (this.isMetaPriceDescription) {
        alert(
          '타 사이트를 통해 방문 후 장바구니 구매 시 일부 쿠폰 사용이 제한됩니다.'
        );
      }

      const aBasketItemList = [];
      for (let i = 0; i < aOptionNoForCart.length; i += 1) {
        aBasketItemList.push({
          mainDealSrl: parseInt(sMainDealSrlForCart, 10),
          dealSrl: parseInt(aOptionNoForCart[i], 10),
          count: parseInt(aCountForCart[i], 10),
          price: parseInt(aPrice[i], 10),
        });
      }

      TMON.oApp.oApi.fetchApi('addCartItems', {
        data: JSON.stringify({
          basketItemList: aBasketItemList,
          key: $.cookie('TMON_CART')
            ? $.cookie('TMON_CART')
            : userCartKeyAtNonLogin,
          platform: TMON.oApp.sPlatform === 'PW' ? 'PC' : 'M_WEB',
        }),
      });
    }

    const trackingParams = makeTrackingParams();

    TMON.oApp.oTracker.dealTracking(
      trackingParams,
      SINGULAR_CONFIG.eventName.addToCart
    );

    // 카트담기 로그 전송
    this.sendCartLog(sMainDealSrlForCart, aOptionNoForCart, aCountForCart);

    function makeTrackingParams() {
      const isAppMode = TMON.view_mode === 'app';
      const staticTrackingParams = {
        ...getStaticParams(isAppMode),
        currency: 'KRW',
      };

      if (!isAppMode) {
        return {
          ...staticTrackingParams,
          price: aPrice,
          quantity: aCountForCart,
          content_option_id: aOptionNoForCart.map(data => `${data}`),
        };
      }

      const result = aOptionNoForCart.reduce((carts, cart, index) => {
        const price = parseInt(aPrice[index], 10);
        const quantity = parseInt(aCountForCart[index], 10);

        carts.push({
          ...staticTrackingParams,
          price,
          quantity,
          optionDealSrl: `${parseInt(cart, 10)}`,
        });

        return carts;
      }, []);

      return { items: result };
    }

    function getStaticParams(isAppMode) {
      const mainDealSrl = `${parseInt(sMainDealSrlForCart, 10)}`;
      const contentType = `${TMON.oApp.oUtil.getMainCategoryNo()}`;
      if (!isAppMode) {
        return {
          content_main_id: Array(aOptionNoForCart.length).fill(mainDealSrl),
          content_type: Array(aOptionNoForCart.length).fill(contentType),
        };
      }

      return {
        mainDealSrl,
        contentType,
      };
    }
  }

  /**
   * addCartItems 결과인 storage 값으로 카트담기 결과를 처리
   */
  processCartAdded() {
    TMON.bIsAvailAddToCart = true;

    const res = TMON.oApp.htStorage.addCartItems;

    if (!res) {
      TMON.oApp.errorHandler({ from: 'CartManager - processCartAdded' });
      return;
    }

    if (res.httpCode !== 200) {
      TMON.oApp.errorHandler({
        from: 'CartManager - processCartAdded',
        error: res,
      });
      let sErrorMsg =
        '일시적인 장애이거나, 1인당 최대 구매수량을 초과한 상품, 매진 및 판매종료된 상품이 있습니다. 상품의 수량을 다시 확인해 주세요.';
      if (res.data && res.data.exceptionCode === 'DIRECT_LOGIN_FAIL') {
        // sErrorMsg = '로그인 이후로 시간이 많이 지났거나, 다른 페이지에서 로그아웃하였습니다. 페이지 새로고침 후 다시 로그인하여 카트담기를 진행해 주세요.';
        TMON.bLogin = false;
        TMON.oApp.setStorage('validateAddToCart');
        return;
      }
      if (res.data && res.data.exceptionMessage) {
        sErrorMsg = res.data.exceptionMessage;
      }
      alert(sErrorMsg);
      return;
    }

    this.showCartPopup();

    // 카트 담기 성공 이후 카트 아이템 비움
    // isAvailableOptionSelect 가 true 일 때 비움 (option selector 사용 가능할 때만 비움)
    if (TMON.oApp.htStorage.optionInfo.isAvailableOptionSelect) {
      TMON.oApp.setStorage('innerCartItems', {
        sAction: 'initialize',
        aList: [],
      });
    }

    // 상단 header 카트 아이콘에 개수 변경
    if (TMON.oApp.sPlatform === 'PW' && res.data.count) {
      $('header li.cart .cnt')
        .html(res.data.count)
        .show();
      $('#skyscraper .cart em')
        .html(res.data.count)
        .show();
    } else if (TMON.oApp.sPlatform !== 'PW' && res.data.count) {
      $('nav.top .cnt')
        .text(res.data.count)
        .show();
    }

    // 비로그인 상태일 시 쿠키에 카트키 저장
    if (!TMON.bLogin && res.data.key) {
      try {
        $.cookie('TMON_CART', res.data.key, {
          expires: 30,
          path: '/',
          domain: 'tmon.co.kr',
          secure: false,
        });
      } catch (e) {
        // console.log(e);
      }
    }

    TMON.oApp.oApi.fetchApi('orderCount');
  }

  async showCartPopup() {
    if (!TMON.oApp.htStorage.adDealList) {
      await TMON.oApp.oApi.fetchApi('adDealList');
    }

    if (!TMON.oApp.htStorage.adDealList.data || !TMON.oApp.htStorage.adDealList.data.length) {
      if (TMON.oApp.sPlatform === 'PW') {
        // 추천 상품이 없으면 팝업 html 변경
        const sHtml = `      
          <h3 class="c-popup__title">장바구니 담기 완료</h3>
          <p class="c-popup__message">
            선택하신 상품을 장바구니에 담았습니다.
          </p>
          <div class="c-popup__button">
            <button type="button" class="c-button c-button--secondary" data-role="closeThisPop">쇼핑계속하기</button>
            <button type="button" class="c-button c-button--primary" data-role="goCart">장바구니</button>
          </div>
          <button type="button" class="c-popup__close" data-role="closeThisPop"><span class="hide">팝업닫기</span></button>`;
        $('.c-popup__body').html(sHtml);
        $('[data-role=addCartWrap]').removeClass('c-popup--lg');
        $('[data-role=addCartWrap]').show();
      } else {
        // 추천 상품이 없으면 팝업 대신 카트담기 성공 toast 띄움
        TMON.oApp.setStorage('toast', '선택한 상품이 장바구니에 담겼습니다.');
      }
    } else {
      // PC에 스와이퍼 init이 안되어 있고 MW 바텀시트가 렌더링 안되었을 때 장바구니 팝업 렌더링
      if (!this.oSwiper && !$('.keep-cart__info').length) {
        this.renderCartPopup();
      }
      $('[data-role=addCartWrap]').show();
      if (TMON.oApp.sPlatform === 'PW') {
        this.initSwiper();
      } else {
        $("body").css("overflow", "hidden");
        $("body").css("width", "100%");
        this.originPopupHeight = $('.keep-cart__content').height();
        this.setHideBottomEvent();
      }
    }
  }

  renderCartPopup() {
    if (TMON.sDevice === 'PW') {
      const sHtml = `
        <h4 class="c-popup__subtitle">같이 구매하면 좋을 상품<i class="suggest">AD</i></h4>
        <div class="c-swiper c-swiper--sm swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events">
           <ul class="swiper-wrapper" id="swiper-wrapper-8b76d08f143dadf9" aria-live="polite">
           ${this.dealListHTML()}
           </ul>
           <button type="button" class="swiper-button-prev" tabindex="0" aria-label="Previous slide" aria-controls="swiper-wrapper-8959d1859bd01ad6"><span class="hide">이전</span></button>
           <button type="button" class="swiper-button-next" tabindex="0" aria-label="Next slide" aria-controls="swiper-wrapper-8959d1859bd01ad6"><span class="hide">다음</span></button>
        </div>
      `;
      $('.keep-cart .c-popup__button').after(sHtml);
    } else {
      const dealImage = document.querySelector('meta[property="og:image"]').getAttribute('content');
      const dealTitle = document.querySelector('meta[property="og:title"]').getAttribute('content');
      const sHtml = `
        <h3 class="hide">장바구니 알림</h3>
        <div class="keep-cart__info">
          <p class="noti">
            <!-- [D] 대체 텍스트는 해당 상품의 상품명으로 변경 -->
            <img src=${dealImage} alt=${dealTitle} style="width: 40px; height: 40px;">
            장바구니에 상품을 담았습니다.
          </p>
          <a data-role="goCart">바로가기</a>
        </div>
        <section class="card_deallist">
          <div class="card_deallist_header">
            <h4 class="card_deallist_title">같이 구매하면 좋을 상품<i class="suggest">AD</i></h4>
          </div>
          <div class="card_deallist_body">
            <ul class="card_deallist_list ">
              ${this.dealListHTML()}
            </ul>
          </div>
        </section>

        <button type="button" class="keep-cart__touch">
          <span class="hide">닫기</span>
          <i class="touch"></i>
        </button>
      `;
      $('.keep-cart__content').html(sHtml);
    }
    this.setPopupEvent();
  }

  dealListHTML() {
    let sHtml = '';
    let { data: dealList } = TMON.oApp.htStorage.adDealList;

    if (TMON.sDevice === 'PW') {
      // 한 슬라이드에 보여지는 딜이 3개보다 적을 때 빈 <li>를 만들어 슬라이드를 채움
      const neededNulls = (3 - (dealList.length % 3)) % 3;
      dealList = dealList.concat(Array(neededNulls).fill(null));
    }

    for (const dealItem of dealList) {
      if (TMON.sDevice === 'PW') {
        if (dealItem) {
          sHtml += `
            <li class="p-item swiper-slide swiper-slide-duplicate" role="group">
              <a href=${this.getAiDealUrl(dealItem)}>
                <!-- 썸네일 -->
                <div class="p-item__figure">
                    ${TMON.oApp.oUtil.getDealMaskHtml(dealItem)}
                    <img class="p-item__thumb" width="133" height="133" style="width: 133px; height: 133px;" src=${
                      dealItem.imageInfo.mobile3ColImageUrl
                    } alt=${dealItem.title}> 
                </div>
                <!-- info 영역 -->
                <div class="p-item__info">
                    <!-- 여행상품 위치, 옵션정보 -->
                    <!-- 상품명 -->
                    <div class="p-item__title">${dealItem.title}</div>
                    <!-- 가격 -->
                    <div class="p-item__price">
                        <!-- 할인가 -->
                        <strong class="price">
                            <i class="hide">판매가:</i>
                            <span>${TMON.util.numberWithComma(
                              dealItem.priceInfo.price
                            )}</span>원~
                        </strong>
                    </div>
                    <!-- 가격 상세설명 -->
                    <!-- 무료배송 -->
                    ${
                      dealItem.deliveryInfo.deliveryFeePolicy === "FREE"
                        ? `<div class="p-item__ship">
                              <div class="item-delivery">
                                  무료배송
                              </div>
                          </div>`
                        : ""
                    }
                    <!-- 추가 정보 -->
                    <!-- 별점 / 구매갯수 -->
                    <div class="p-item__detail">
                      ${
                        dealItem.dealMax.buyCount > 0
                          ? `<span class="buy-count">${TMON.util.numberWithComma(
                              dealItem.dealMax.buyCount
                            )}개 구매</span>`
                          : ""
                      }
                    </div>
                </div>
              </a>
            </li>
          `;
        } else {
          sHtml += `<li class="p-item swiper-slide swiper-slide-duplicate" role="group"><div></div></li>`
        }
      } else {
        sHtml += `
          <li class="card_deallist_item">
            <a href=${this.getAiDealUrl(dealItem)} class="card_deallist_link">
              <div class="card_deallist_thumb">
                <img src=${dealItem.imageInfo.mobile3ColImageUrl} alt=${dealItem.title}>
                <!-- 딜리스트 마스크 -->
                ${TMON.oApp.oUtil.getDealMaskHtml(dealItem)}
              </div>
              <div class="card_deallist_info">
                <p class="title">${dealItem.title}</p>
                <div class="price_area">
                  <span class="price">${TMON.util.numberWithComma(
                    dealItem.priceInfo.price
                  )}원</span>
                </div>
              </div>
            </a>
          </li>
        `;
      } 
    }
    return sHtml;
  }

  getAiDealUrl(item) {
    return TMON.util.aup(
      `${item.admonUrl}&fwUrl=${encodeURIComponent(
        TMON.util.aup(
          `${TMON.htLocal.htURL.www_m_deals}${item.dealNo}`,
          TMON.sAppQuery
        )
      )}`,
      TMON.sAppQuery
    );
  }

  initSwiper() {
    const { data: dealList } = TMON.oApp.htStorage.adDealList;
    const SLIDE_PER_VIEW = 3;
    const anchors = $('[data-role=addCartWrap] a');
    this.oSwiper = new Swiper(".c-swiper", {
      slidesPerView: SLIDE_PER_VIEW,
      slidesPerGroup: SLIDE_PER_VIEW,
      spaceBetween: 16,
      autoplay: dealList.length > 3 ? { delay: 3000 } : false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        init() {
          // 네비게이션 버튼이 필요하지 않을 때 버튼숨김
          if (dealList.length <= SLIDE_PER_VIEW) {
            $('[data-role=addCartWrap] .swiper-button-next').hide();
            $('[data-role=addCartWrap] .swiper-button-prev').hide();
          }

          const firstSlideItemCount = dealList.length <= SLIDE_PER_VIEW ? dealList.length : SLIDE_PER_VIEW;
          for (let i = 0; i < firstSlideItemCount; i++) {
            const anchor = anchors.eq(i);
            if (!anchor.data('sendedlog') && anchor.length) {
              sendCPCLog(anchor, 'IMPRESSION', 'CPC_AI');
              anchor.attr('data-sendedlog', true);
            }
          }
        },
        slideChange() {
          for (let i = this.activeIndex; i < this.activeIndex + SLIDE_PER_VIEW; i++) {
            const anchor = anchors.eq(i);
            if (!anchor.data('sendedlog') && anchor.length) {
              sendCPCLog(anchor, 'IMPRESSION', 'CPC_AI');
              anchor.attr('data-sendedlog', true);
            }
          }
        }
      }
    });
  }

  /**
   * 카트담기 클릭시 카트 정보 수집을 위한 로그 전송
   * @param {String} sMainDealSrlForCart
   * @param {Array} aOptionNoForCart
   * @param {Array} aCountForCart
   */
  sendCartLog(sMainDealSrlForCart, aOptionNoForCart, aCountForCart) {
    const dealInfoList = aOptionNoForCart.map((optionNoForCart, idx) => {
      const mainDealSrl = parseInt(sMainDealSrlForCart, 10);
      const optionSrl = parseInt(optionNoForCart, 10);
      const cnt = parseInt(aCountForCart[idx], 10);

      return {
        main_deal_srl: mainDealSrl,
        option_srl: optionSrl,
        cnt,
      };
    });
    const params = {
      date: new Date().getTime(),
      pid: window.tl_vars ? window.tl_vars.p_id : '',
      sid: window.tl_vars ? window.tl_vars.s_id : '',
      // 현재 개인정보 보호법으로 member serial 정보는 client에서 가지고 있지 않아 ''로 전송
      m_srl: window.tl_vars && window.tl_vars.m_no ? window.tl_vars.m_no : '',
      platform: '',
      agent: '',
      version: '',
      user_ip: TMON.userIp,
      action: 'ins',
      type: 'user',
      deal_info: JSON.stringify(dealInfoList),
    };

    if (TMON.sDevice === 'PW') {
      params.platform = 'pc';
    } else if (TMON.sDevice === 'MI' || TMON.sDEvice === 'MA') {
      params.platform = 'mapp';
    } else if (TMON.sDevice === 'MW') {
      params.platform = 'mweb';
    }

    if (TMON.bIsAndroid) {
      params.agent = 'Android';
      params.version = TMON.appAndroidMarketVersion;
    } else if (TMON.bIsIos) {
      params.agent = 'iOS';
      params.version = TMON.appIosMarketVersion;
    } else if (TMON.bIsMac) {
      params.agent = 'Mac';
    } else if (TMON.bIsWindows) {
      params.agent = 'Windows';
    }

    let url = `${location.protocol}//wlog.tmon.co.kr/cart.html`;
    url += `?curtime=${new Date().getTime()}`;
    url += `&${$.param(params)}`;
    url += `&referer=${encodeURIComponent(window.location.href)}`;

    const img = new Image();
    img.src = url;
  }

  setMetaDescription() {
    // [SDLUI-2158] Appendix 특정 제휴사 유입코드인 경우 제휴사 혜택 문구 처리
    // Appendix 특정 제휴사 메타채널 유입 여부 서버 관리 필요
    if (TMON.htCommonStaticInfo.meta.isMetaPriceDescription()) {
      this.isMetaPriceDescription = true;
      document.getElementById('_metaPriceDescription').style.display = '';
    }
  }
}
